import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export const patientSubscriptionUpgradeQueryKey = (patientId: string) =>
  ['patient', patientId, 'subscription', 'upgrade'] as const

/**
 * Fetches Stripe-computed prorations when staff explicitly request
 * upgrade pricing. Each fetch generates a preview invoice on Stripe,
 * so we use a long staleTime to avoid unnecessary API calls. The
 * prorated total drifts by fractions of a penny per hour, so
 * staleness is cosmetic.
 */
export function useGetPatientSubscriptionUpgrade(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: patientSubscriptionUpgradeQueryKey(patientId),
    enabled: false,
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/subscription/upgrade', {
        params: { patientId },
      })
      return dataOrThrow(response)
    },
  })
}
